<!-- @format -->

<company-info-first>
  <div class="contents">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_application">会社情報</h1>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="{ routes.makePath('top-tag') }" class="home">ホーム</a>
          </li>
          <li class="breadcrumb-item">会社情報</li>
        </ul>
      </div>
      <!--/.container_heading-->

      <div class="lead_block">
        <p>
          以下の情報が登録されております。
          <br />
          登録情報の変更を行う場合は、法人申請と同様に事務局側で確認を行う必要があります。
          <br />
          社名や、住所、連絡先の変更をする必要が生じた場合は、「
          <strong>登録情報の変更依頼をする</strong>
          」からお手続きをしてください。
        </p>
      </div>
      <!--/.lead_block-->

      <div class="contents_block detail">
        <company-detail data="{ props.params }" prefs="{ props.prefs }"></company-detail>

        <div class="container_button">
          <button
            class="button button-primary"
            type="button"
            value="登録情報の変更依頼をする"
            data-target=""
            onclick="{ props.onSubmit }"
          >
            登録情報の変更依頼をする
          </button>
        </div>
        <!--/.container_button-->
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->
  <script>
    import detail from "@tags/parts/company-detail.riot";
    import routes from "@model/menu-routes.js";

    export default {
      components: {
        "company-detail": detail,
      },
      onBeforeMount(props, state) {
        this.routes = routes;
      },
    };
  </script>
</company-info-first>
